import MicroModal from 'micromodal'

const openModal = (options) => {
  console.debug('openModal options:', options)
  options.id = options.id || 'provenance-modal'
  options.variant = options.variant || 'full'

  if (options.url.includes('/journeys') && !options.url.includes('/modal')) {
    options.url += '/modal'
  }

  const uri = new URL(options.url, document.location.origin)
  uri.searchParams.set('modal', options.variant)
  options.url = uri.toString()

  if (window.xprops && typeof window.xprops.openModal === 'function') {
    openModalFromEmbed(options)
    return
  }

  const buildModalElement = ({ id, variant, behavior }) => {
    const template = document.createElement('template')
    template.innerHTML = modalHtml({
      id,
      classes: `ProvenanceModal--${variant}Variant ${behavior ? `ProvenanceModal--${behavior}Behavior` : ''}`
    })
    const modal = template.content.firstElementChild.cloneNode(true)
    return modal
  }

  /**
   * Builds the HTML for Micromodal.js to display a modal.
   * It is intended to be added at the bottom of the page, before </body>.
   *
   * @param {string} id - a valid, unique HTML ID (required for Micromodal.js)
   * @param {string} [classes] - additional CSS classes (optional)
   * @returns {string}
   */
  const modalHtml = ({ id, classes }) =>
  `
  <div id="${id}" class="ProvenanceModal APP ${classes || ''}" aria-hidden="true">
    <div class="ProvenanceModal-backdrop" tabindex="-1" data-micromodal-close>
      <div class="ProvenanceModal-dialog" role="dialog" aria-modal="true" aria-labelledby="${id}">
        <button class="ProvenanceModal-closeBtn" aria-label="Close modal" data-micromodal-close>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" fillrule="evenodd">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="0.5"></circle>
              <g strokelinecap="round" strokelinejoin="round" strokewidth="2">
                <path d="M8 16l8-8M8 8l8 8"></path>
              </g>
            </g>
          </svg>
        </button>
        <div class="ProvenanceModal-content"></div>
      </div>
    </div>
  </div>
  `

  const insertContentInModal = (modal, content) => {
    modal
      .querySelector('.ProvenanceModal-content')
      .insertAdjacentHTML('beforeend', content)
  }

  const openDrawer = modal => {
    modal.dataset.state = 'drawer-open'
  }

  const closeDrawer = (modal, callback) => {
    modal.dataset.state = 'drawer-closed'
    modal.addEventListener('transitionend', callback)
  }

  const showModal = id => {
    MicroModal.show(id, {
      onShow: modal => {
        if (options.behavior === 'drawer') {
          openDrawer(modal)
        }
      },
      onClose: modal => {
        if (options.behavior === 'drawer') {
          closeDrawer(modal, e => {
            modal.remove()
          })
        } else {
          modal.remove()
        }
      },
      disableScroll: true
    })
  }

  // Add layout param to URL for modals handled internally
  uri.searchParams.set('layout', false)
  options.url = uri.toString()

  const modal = buildModalElement(options)
  document.body.appendChild(modal)

  fetch(options.url)
    .then(response => response.text())
    .then(text => {
      insertContentInModal(modal, text)
      showModal(options.id)
    })
    .catch(err => {
      console.error('modalOpen fetch error:', err)
    })
}

const openModalFromEmbed = opts => {
  const { xprops } = window
  console.debug('openModalFromEmbed', opts, 'xprops:', xprops)

  if (xprops.version) {
    xprops.openModal(opts)
  } else {
    // All code below is for legacy support (SDK <= v0.6)
    console.warn('[Deprecation Notice] A legacy version of Provenance SDK has been detected. Please upgrade to the latest version: https://www.npmjs.com/package/@provenance/provenance-sdk')

    if (opts.slug) {
      console.debug('[app] xprops.openModal slug', opts.slug.toLowerCase())
      xprops.openModal(opts.slug.toLowerCase())
    } else if (opts.url) {
      console.debug('[app] xprops.openModal url', opts.url)

      if (opts.url.includes('/journeys')) {
        // Extract slug from URL
        if (/\/.*\/journeys/.test(opts.url)) {
          console.debug('locale detected in url')
          const { pathname } = new URL(opts.url)
          const slug = pathname.split('/')[3].toLowerCase()
          xprops.openModal(slug)
        } else {
          console.debug('locale not detected in url')
          const slug = opts.url.split('/')[2].toLowerCase()
          xprops.openModal(slug)
        }
        return
      }

      xprops.openModal(opts.url)
    } else {
      console.error('Provenance app openModal error: No slug or url present') // This should never happen
    }
  }
}

export default openModal
